import { render, staticRenderFns } from "./LoanableOverview.vue?vue&type=template&id=8f3f5932"
import script from "./LoanableOverview.vue?vue&type=script&lang=js"
export * from "./LoanableOverview.vue?vue&type=script&lang=js"
import style0 from "./LoanableOverview.vue?vue&type=style&index=0&id=8f3f5932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports